import React, { Component } from "react";
//import * as _ from "lodash";
import seedrandom from "./seedrandom";

import QuizUi from "./widgets/QuizUi";

import {
  getLocale,
  getLocaleShortWeekday,
  getLocaleLongMonth,
  getLocaleShortMonth,
} from "./util/localisation";

import {
  PRACTICEFORMAT_ISO,
  PRACTICEFORMAT_LONGMONTH,
} from './util/constants';

import {
  getPracticeFormat,
  getVisits,
} from "./util/settings";

import "./QuizDay.css";

const RESULTS_KEY = "RESULTS";

export const daysInMonth = (year, month) => {
  const date = new Date();
  date.setHours(12);
  date.setDate(1);
  date.setMonth(month);
  date.setFullYear(year);
  date.setMonth(month + 1);
  date.setDate(0);
  return date.getDate();
};

export const dayStrToParts = (str) => {
  const [y, m, d] = str.split("-");

  return {
    year: parseInt(y, 10),
    month: parseInt(m, 10) - 1,
    date: parseInt(d, 10),
  };
};

export const dayPartsToStr = (y, m, d) => {
  return y + "-" + pad2(m + 1) + "-" + pad2(d);
};

export const dayOfWeek = (year, month, day) => {
  const date = new Date();
  date.setHours(12);
  date.setDate(1);
  date.setFullYear(year);
  date.setMonth(month);
  date.setDate(day);
  return date.getDay();
};

export const pad2 = (n) => (n < 10 ? "0" : "") + n;

const DISPLAY_FORMAT_ISO = "ISO";
const DISPLAY_FORMAT_SHORTMONTH = "SHORTMONTH";
const DISPLAY_FORMAT_SHORTMONTH_MDY = "SHORTMONTH_MDY";
export const DISPLAY_FORMAT_LONGMONTH = "LONGMONTH";
export const DISPLAY_FORMAT_LONGMONTH_MDY = "LONGMONTH_MDY";

const DISPLAY_FORMAT_SLASHES = "SLASHES";
const DISPLAY_FORMAT_SLASHES_MDY = "SLASHES_MDY";

const getRandomDateFormatRnd = (day, month, rand) => {
  const locale = getLocale();

  if (locale.formatYMD) {
    if (rand < 1 / 3) {
      return DISPLAY_FORMAT_ISO;
    }
    if (rand < 2 / 3) {
      return DISPLAY_FORMAT_SHORTMONTH;
    }
    return DISPLAY_FORMAT_LONGMONTH;
  }

  if (locale.formatDMY && locale.formatMDY) {
    if (day === month + 1) {
      // unambiguous due to month and day the same
      return DISPLAY_FORMAT_SLASHES;
    } else if (day <= 12) {
      if (rand < 0.33) {
        return DISPLAY_FORMAT_ISO;
      }
      if (rand < 0.66) {
        return DISPLAY_FORMAT_SHORTMONTH;
      }
      return DISPLAY_FORMAT_LONGMONTH;
    } else {
      // day is 13 or above, not ambigous
      if (rand < 0.2) {
        return DISPLAY_FORMAT_ISO;
      }
      if (rand < 0.35) {
        return DISPLAY_FORMAT_SLASHES;
      }
      if (rand < 0.5) {
        return DISPLAY_FORMAT_SLASHES_MDY;
      }
      if (rand < 0.625) {
        return DISPLAY_FORMAT_SHORTMONTH;
      }
      if (rand < 0.75) {
        return DISPLAY_FORMAT_SHORTMONTH_MDY;
      }
      if (rand < 0.875) {
        return DISPLAY_FORMAT_LONGMONTH;
      }
      return DISPLAY_FORMAT_LONGMONTH_MDY;
    }
  }

  if (rand < 0.25) {
    return DISPLAY_FORMAT_ISO;
  }
  if (rand < 0.5) {
    return locale.formatMDY
      ? DISPLAY_FORMAT_SLASHES_MDY
      : DISPLAY_FORMAT_SLASHES;
  }
  if (rand < 0.75) {
    return locale.formatMDY
      ? DISPLAY_FORMAT_SHORTMONTH_MDY
      : DISPLAY_FORMAT_SHORTMONTH;
  }
  return locale.formatMDY
    ? DISPLAY_FORMAT_LONGMONTH_MDY
    : DISPLAY_FORMAT_LONGMONTH;
};

export const formatDateStr = (dateStr, formatRnd, isPractice) => {
  const format = getDateFormat(dateStr, formatRnd, isPractice);
  return applyDateFormat(dateStr, format);
};

const getDateFormat = (dateStr, formatRnd, isPractice) => {
  if (isPractice) {
    const practiceFormat = getPracticeFormat();
    if (practiceFormat === PRACTICEFORMAT_ISO) {
      return DISPLAY_FORMAT_ISO;
    }
    if (practiceFormat === PRACTICEFORMAT_LONGMONTH) {
      const locale = getLocale();
      if (locale.formatMDY) {
        return DISPLAY_FORMAT_LONGMONTH_MDY;
      }
      else {
        return DISPLAY_FORMAT_LONGMONTH;
      }
    }
  }
  const { date, month } = dayStrToParts(dateStr);
  return getRandomDateFormatRnd(date, month, formatRnd);
};

export const applyDateFormat = (dateStr, format) => {
  const { year, month, date } = dayStrToParts(dateStr);

  if (format === DISPLAY_FORMAT_ISO) {
    return year + "-" + pad2(month + 1) + "-" + pad2(date);
  }

  const locale = getLocale();

  if (locale.formatYMD) {
    // chinese etc.
    if (format === DISPLAY_FORMAT_SLASHES) {
      return year + " " + pad2(month + 1) + " " + pad2(date);
    }
    if (format === DISPLAY_FORMAT_SHORTMONTH) {
      return year + " " + getLocaleShortMonth(month) + " " + date;
    }
    if (format === DISPLAY_FORMAT_LONGMONTH) {
      return year + " " + getLocaleLongMonth(month) + " " + date;
    }
  } else {
    if (format === DISPLAY_FORMAT_SLASHES) {
      return pad2(date) + "/" + pad2(month + 1) + "/" + year;
    }
    if (format === DISPLAY_FORMAT_SLASHES_MDY) {
      return pad2(month + 1) + "/" + pad2(date) + "/" + year;
    }
    if (format === DISPLAY_FORMAT_SHORTMONTH) {
      return date + " " + getLocaleShortMonth(month) + " " + year;
    }
    if (format === DISPLAY_FORMAT_SHORTMONTH_MDY) {
      return getLocaleShortMonth(month) + " " + date + ", " + year;
    }
    if (format === DISPLAY_FORMAT_LONGMONTH) {
      return date + " " + getLocaleLongMonth(month) + " " + year;
    }
    if (format === DISPLAY_FORMAT_LONGMONTH_MDY) {
      return getLocaleLongMonth(month) + " " + date + ", " + year;
    }
  }

  return "???";
};

const isAmbigousDateStr = (str) => {
  return str.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/);
};

const duration = (ms) => {
  return Math.min(60000, Math.max(0, ms));
};

export const createQuestionFromSeed = (seed, fromYear, toYear) => {
  let { year, month, date } = dayStrToParts(seed.date);

  if (!(year >= fromYear && year <= toYear)) {
    const modulo = toYear - fromYear + 1;
    const offset = (((year - fromYear) % modulo) + modulo) % modulo;
    year = fromYear + offset;
  }

  const maxDate = daysInMonth(year, month);
  if (date > maxDate) {
    date = 1 + Math.floor(maxDate * new seedrandom(1 + seed.random).quick());
  }

  return {
    year,
    month,
    date,
  };
};

export const createQuestionYearAndMonth = (fromYear, toYear, rng) => {
  let year;
  let forceLeapYear = false;

  const yearRand = rng.quick();

  if (fromYear === 1901 && toYear === 2099) {
    const newRng = new seedrandom(yearRand);

    year =
      newRng.quick() < 0.2
        ? new Date().getFullYear() - 3 + Math.floor(newRng.quick() * 4)
        : 1901 + Math.floor(newRng.quick() * 198);

    if (newRng.quick() < 0.25) {
      forceLeapYear = true;
      year -= year % 4;
    }
  } else {
    year = fromYear + Math.floor(yearRand * (toYear - fromYear + 1));
  }

  const month =
    forceLeapYear && rng.quick() < 0.5
      ? Math.round(rng.quick())
      : Math.floor(rng.quick() * 12);

  return {
    year,
    month,
  };
};

class Quiz extends Component {
  state = {
    question: null,
  };

  componentWillMount() {
    let results;
    try {
      results = JSON.parse(window.localStorage.getItem(RESULTS_KEY));
      if (!(results instanceof Array)) {
        throw new Error();
      }
    } catch (err) {}
    if (!results) {
      results = [];
    }

    this.setState({
      results,
    });

    if (this.props.isPractice && getVisits() < 10 && results.length < 20) {
      this.setState({
        showDateTip: true,
      });
    }

    this.createQuestion();
  }

  componentDidUpdate(prevProps) {
    if (this.props.seed !== prevProps.seed) {
      this.createQuestion();
    }
  }

  /*
  
  Sun  Mon  Tue   Wed
  
  Thu  Fri  Sat  *Skip*

  */

  createQuestion() {
    const { fromYear, toYear, seed } = this.props;

    //const { year, month } = createQuestionYearAndMonth(fromYear, toYear, rng);

    const { year, month, date } = createQuestionFromSeed(
      seed,
      fromYear,
      toYear
    );

    const dateStr = dayPartsToStr(year, month, date);
    const displayFormatRnd = new seedrandom("FORMAT_" + seed.random).quick();

    this.setState({
      question: {
        dateStr,
        displayFormatRnd,
        generated: Date.now(),
      },
    });
  }

  pushResult = (correct) => {
    const { results } = this.state;

    results.unshift([
      correct,
      duration(Date.now() - this.state.question.generated, false),
    ]);

    if (results.length > 1000) {
      results.length = 1000;
    }

    this.setState({
      results,
    });

    window.localStorage.setItem(RESULTS_KEY, JSON.stringify(results));
  };

  onAnswer = (isCorrect, answer, elapsed, isSkip) => {
    this.pushResult(isCorrect);
  };

  onAfterAnswerWait = (wasCorrect, answer, timeElapsedUponAnswer, isSkip) => {
    if (wasCorrect || isSkip) {
      this.props.resetSeed();
    }
  };

  render() {
    const { isPractice } = this.props;

    const { question, showDateTip } = this.state;
    if (!question) {
      return null;
    }

    return (
      <DayQuestion
        isPractice={isPractice}
        showDateTip={showDateTip}
        dateStr={question.dateStr}
        displayFormatRnd={question.displayFormatRnd}
        allowMultiGuess
        startTime={question.generated}
        onAnswer={this.onAnswer}
        onAfterAnswerWait={this.onAfterAnswerWait}
      />
      /*
        <ResultsTable results={results} />
      </DayQuestion>
      */
    );
  }
}

export class DayQuestion extends Component {
  state = {
    elapsed: 0,
  };

  componentDidMount() {
    this.startTicking();
    this.setState({
      mountTime: Date.now(),
    });
  }

  componentWillUnmount() {
    clearTimeout(this.afterAnswerTimeout);
    clearInterval(this.tickInterval);
  }

  startTicking = () => {
    clearInterval(this.tickInterval);
    this.tickInterval = setInterval(this.tick, 100);
  };

  tick = () => {
    this.setState({
      elapsed: this.calculateElapsed(),
    });
  };

  calculateElapsed = () => {
    const { startTime } = this.props;
    const start =
      typeof startTime === "number" ? startTime : this.state.mountTime;
    return Date.now() - start;
  };

  onGuessClick = (guess) => {
    clearTimeout(this.afterAnswerTimeout);

    const { year, month, date } = dayStrToParts(this.props.dateStr);
    const correctAnswer = dayOfWeek(year, month, date);
    const isSkip = guess === 7;
    const isCorrect = guess === correctAnswer || (isSkip ? null : false);

    this.answer = guess;
    this.timeElapsedUponAnswer = this.calculateElapsed();

    this.setState({
      answer: guess,
    });

    if (isCorrect) {
      this.onGuessCorrect(guess);
    } else {
      this.onGuessWrong(guess, isSkip);
    }

    this.props.onAnswer(isCorrect, guess, this.timeElapsedUponAnswer, isSkip);
  };

  onGuessCorrect = (guess) => {
    clearInterval(this.tickInterval);

    this.setState(
      {
        correctGuess: guess,
        wrongGuess: null,
      },
      this.clearColorsWait
    );
  };

  onGuessWrong = (guess, isSkip) => {
    if (!this.props.allowMultiGuess || isSkip === null) {
      clearInterval(this.tickInterval);
    }

    this.setState(
      {
        wrongGuess: guess,
        correctGuess: null,
        isSkip,
      },
      this.clearColorsWait
    );
  };

  clearColorsWait = () => {
    this.afterAnswerTimeout = setTimeout(this.clearColors, 750);
  };

  clearColors = () => {
    const wasCorrect = typeof this.state.correctGuess === "number";
    const isSkip = this.state.isSkip;

    if (this.props.onAfterAnswerWait) {
      this.props.onAfterAnswerWait(
        wasCorrect,
        this.answer,
        this.timeElapsedUponAnswer,
        isSkip
      );
    }

    this.setState({
      answer: null,
      correctGuess: null,
      wrongGuess: null,
    });

    this.startTicking();
  };

  render() {
    const {
      children,
      dateStr,
      displayFormatRnd,
      allowMultiGuess,
      isPractice,
      showDateTip
    } = this.props;
    const { correctGuess, wrongGuess, answer /*, elapsed */ } = this.state;

    const isCorrect = typeof correctGuess === "number";
    const isWrong = typeof wrongGuess === "number";
    const disabled = isCorrect || (isWrong && !allowMultiGuess);

    //  const dur = duration(elapsed);

    const options = [0, 1, 2, 3, 4, 5, 6];

    const displayFormat = getDateFormat(dateStr, displayFormatRnd, isPractice);
    const displayDateStr = applyDateFormat(dateStr, displayFormat);

    return (
      <QuizUi className="DayQuestion"
        hide789
        onAnswer={this.onGuessClick}
        labels={options.map(getLocaleShortWeekday)}
        highlightWrongIndex={wrongGuess}
        highlightCorrectIndex={correctGuess}
        disabled={disabled}
        isCorrect={isCorrect}
        isWrong={isWrong}
        answer={answer}
        >
        {children}
        <b>{displayDateStr}</b>
        {showDateTip && isAmbigousDateStr(displayDateStr) && (
          <small>
            {displayFormat === DISPLAY_FORMAT_SLASHES_MDY
              ? "MM/DD/YYYY"
              : "DD/MM/YYYY"}
          </small>
        )}
      </QuizUi>
    );
  }
}

/*
class ResultsTable extends Component {
  render() {
    const { results } = this.props;

    const thresholds = [10, 20, 50, 100, 250, 1000];

    const cutoffs = [];
    const percents = [];
    const durations = [];

    let correct = 0;
    let sumDuration = 0;
    for (let i = 0; i < results.length; i++) {
      for (let j = 0; j < thresholds.length; j++) {
        const n = thresholds[j];
        if (i === n) {
          cutoffs.push(n);
          percents[j] = correct / n;
          durations[j] = sumDuration / n;
        }
      }
      correct += results[i][0] ? 1 : 0;
      sumDuration += results[i][1];
    }

    if (cutoffs.length < thresholds.length) {
      cutoffs.push(results.length);
      percents.push(correct / results.length || 0);
      durations.push(sumDuration / results.length || 0);
    }

    while (cutoffs.length < thresholds.length) {
      cutoffs.push(null);
      percents.push(null);
      durations.push(null);
    }

    return (
      <table className="-results">
        <tbody>
          <tr>
            {cutoffs.map((n, index) => (
              <td key={index}>{n === 1000 ? "1k" : n}</td>
            ))}
          </tr>
          <tr>
            {percents.map((percent, index) => (
              <td key={index}>{percent === null ? "" : percentStr(percent)}</td>
            ))}
          </tr>
          <tr>
            {durations.map((dur, index) => (
              <td key={index}>{dur === null ? "" : durStr(dur)}</td>
            ))}
          </tr>
        </tbody>
      </table>
    );
  }
}
*/

export default Quiz;
